;
(function() {

    var _opts = {
        text: "",
        iconCss: "",
        isMask: true,
        type: "", //success,wrong,cry,information,refresh,loading
        time: 2000
    };

    var toastList = [];

    HTMLElement.prototype.__appendHTML = function(html) {
        var divTemp = document.createElement("div"),
            nodes = null,
            // 文档片段，一次性append，提高性能
            fragment = document.createDocumentFragment();
        divTemp.innerHTML = html;
        nodes = divTemp.childNodes;
        for (var i = 0, length = nodes.length; i < length; i += 1) {
            fragment.appendChild(nodes[i].cloneNode(true));
        }
        this.appendChild(fragment);
        // 据说下面这样子世界会更清净
        nodes = null;
        fragment = null;
    };

    var toastModel = {
        container: ""
    };

    var methods = {
        show: function(opts) {
            var id = "js-toast" + (new Date()).getTime();
            var toastOpts = Object.assign({}, { id: id }, opts);
            var html = getTmpl(toastOpts);
            document.body.__appendHTML(html);
            var container = document.getElementById(id);
            toastModel.container = container;
            var mask = container.getElementsByClassName("js-toast-mask")[0];
            var icon = container.getElementsByClassName("js-toast-icon")[0];
            if (opts.isMask) {
                mask.style.display = "block";
            } else {
                mask.style.display = "none";
            }

            if (opts.type.length > 0) {
                icon.style.display = "block";
            } else {
                icon.style.display = "none";
            }

            var loadingBody = container.getElementsByClassName("js-toast-inner-body")[0];

            addClass(loadingBody, "js-toast-below");
            setTimeout(function() {
                addClass(loadingBody, "js-toast-show");
            }, 100);

            toastList.push(toastOpts);
            if (!(opts.time == -1)) {
                close(container, opts);
            }
        }
    };

    function getTmpl(opts) {
        var iconType = ""; //icon-success,icon-cry,icon-information,icon-refresh,icon-wrong
        if (opts.type == "") {
            iconType = "";
        } else {
            iconType = "myiconfont myicon-" + opts.type;
        }
        var html = `<div class="js-toast" id="${opts.id}">
                        <div class="js-toast-body">
                            <div class="js-toast-inner-body">
                                <div class="js-toast-ib-ctn">
                                    <div class="${iconType} ${opts.iconCss} js-toast-icon"></div>
                                    <div class="js-toast-text">${opts.text}</div>
                                </div>
                                <div class="js-tast-inner-mask"></div>
                            </div>
                        </div>
                        <div class="js-toast-mask"></div>
                    </div>`;
        return html;
    }

    function close(domContainer, opts) {
        var loadingBody = domContainer.getElementsByClassName("js-toast-inner-body")[0];
        setTimeout(function() {
            removeClass(loadingBody, 'js-toast-show');
            setTimeout(function() {
                document.body.removeChild(domContainer);
            }, (100));
        }, opts.time);
    }

    function removeClass(obj, cls) {
        var obj_class = ' ' + obj.className + ' ', //获取 class 内容, 并在首尾各加一个空格. ex) 'abc    bcd' -> ' abc    bcd '
            obj_class = obj_class.replace(/(\s+)/gi, ' '), //将多余的空字符替换成一个空格. ex) ' abc    bcd ' -> ' abc bcd '
            removed = obj_class.replace(' ' + cls + ' ', ' '); //在原来的 class 替换掉首尾加了空格的 class. ex) ' abc bcd ' -> 'bcd '
        removed = removed.replace(/(^\s+)|(\s+$)/g, ''); //去掉首尾空格. ex) 'bcd ' -> 'bcd'
        obj.className = removed; //替换原来的 class.
    }


    function addClass(obj, cls) {
        var obj_class = obj.className, //获取 class 内容.
            blank = (obj_class != '') ? ' ' : '', //判断获取到的 class 是否为空, 如果不为空在前面加个'空格'.
            added = obj_class + blank + cls; //组合原来的 class 和需要添加的 class.
        obj.className = added; //替换原来的 class.
    }

    window.jToast = {
        show: function(options) {
            var opts = Object.assign({}, _opts, options);
            methods.show(opts);
        },
        loading: function(titles) {
            var tips = titles ? titles : "数据加载中...";
            jToast.show({
                type: "loading",
                text: tips,
                time: -1
            });
        },
        close: function() {
            close(toastModel.container, { time: 0 });
        }
    };

})();


// WEBPACK FOOTER //
// ./src/lib/js-toast/js-toast.js